var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.01204 0.0952148C4.40954 0.0952148 0.678711 3.82604 0.678711 8.42854C0.678711 13.031 4.40954 16.7619 9.01204 16.7619C13.2454 16.7619 16.7987 13.5885 17.2937 9.41852C17.347 8.96103 17.0212 8.53521 16.5637 8.48021C16.107 8.42688 15.6804 8.75269 15.627 9.21019C15.2312 12.5435 12.3987 15.0952 9.01204 15.0952C5.33037 15.0952 2.34538 12.1102 2.34538 8.42854C2.34538 4.74687 5.33037 1.76188 9.01204 1.76188C9.7812 1.76188 10.5429 1.90104 11.252 2.15271C11.6854 2.30604 12.1395 2.06521 12.2937 1.63187C12.447 1.19771 12.232 0.717724 11.7987 0.563557C10.912 0.249391 9.9712 0.0952148 9.01204 0.0952148ZM16.512 1.76188C16.2987 1.76188 16.0754 1.83688 15.9129 1.99605L8.64703 9.1577C8.43287 9.36853 8.21703 9.32771 8.0487 9.07937L7.21537 7.85521C6.96037 7.47938 6.42537 7.37021 6.04371 7.62104C5.66121 7.87187 5.55371 8.39104 5.80871 8.76687L6.64204 9.99103C7.39288 11.0985 8.86203 11.2452 9.81953 10.3035L17.1112 3.16853C17.4362 2.84853 17.4362 2.31605 17.1112 1.99605C16.9487 1.83605 16.7254 1.76188 16.512 1.76188Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/checkCircle.a24b86642135002a2c0de015a87ed052.svg";
export { ForwardRef as ReactComponent };